import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import $ from 'jquery'
import { TabContext } from '@mui/lab'
import { Tab, Tabs } from '@mui/material'

import { Logger, LoggerTypes } from '../../../../utils'
import { TabPanel } from '../../../../components'
import { ScenarioAttributesTabs } from '../../../scenarios'
import { FlowActionsAccordion } from '../FlowActionsAccordion'
import { FlowGroupsAccordion } from '../FlowGroupsAccordion'
import './style.scss'

/**
 *
 * @param {object} currentProject Object of the current selected project.
 * @param {object} currentScenario Object of the current selected scenario.
 * @param {object} currentFlowGroup Object of the current selected flow group.
 * @param {array<object>} resourceItems Array of resource objects that belong to this scenario.
 * @param {array<object>} productItems Array of product objects that belong to this scenario.
 * @param {array<object>} variableItems Array of variable objects that belong to this scenario.
 * @param {array<object>} locationItems Array of location objects that belong to this scenario.
 * @param {array<object>} weatherItems Array of weather objects that belong to this scenario.
 * @param {array<object>} parameterItems Array of parameter objects that belong to this scenario.
 * @param {array<object>} taskItems Array of tasks objects that belong to this flowGroup.
 * @param {array<object>} conditionItems Array of conditions objects that belong to this flowGroup.
 * @returns {TabContext}
 */
export const FlowListTabs = ({
  currentProject,
  currentScenario,
  currentFlowGroup,
  flowGroups,
  loadData,
  // -- Scenario's Attributes
  resourceItems,
  productItems,
  variableItems,
  locationItems,
  weatherItems,
  parameterItems,
  // -- FlowGroup Actions
  taskItems,
  conditionItems
}) => {
  const [tabValue, setValue] = useState(0)
  const { t } = useTranslation()

  const TAB_PANEL_HEIGHT = `${$(window).height() - 220}px`

  Logger.trace(LoggerTypes.CONTAINER, 'FlowListTabs.init()', { taskItems, conditionItems })

  const onTabChange = (e, newValue) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'FlowListTabs.onTabChange()', { e, newValue })
    setValue(newValue)
  }

  // Logger.trace(LoggerTypes.CONTAINER, 'FlowListTabs.render()', {
  //   loadData,
  //   tabValue,
  //   project: { currentProject },
  //   scenario: {
  //     currentScenario,
  //     attributes: { resourceItems, productItems, variableItems, locationItems, weatherItems, parameterItems }
  //   },
  //   flowGroup: { currentFlowGroup, flowGroups },
  //   flowActions: {
  //     taskItems,
  //     conditionItems
  //   },
  //   TAB_PANEL_HEIGHT
  // })

  return currentProject && currentScenario && tabValue !== undefined ? (
    <div className="FlowListTabs">
      <TabContext value={`${tabValue}`}>
        <Tabs value={tabValue} aria-label="library selector" onChange={onTabChange} className="mainTabs">
          <Tab id="simple-tab-0" disableRipple={true} label={t('flowGroups.left.tabs.flow_groups.title')} />
          <Tab id="simple-tab-1" disableRipple={true} label={t('flowGroups.left.tabs.actions.title')} />
          <Tab id="simple-tab-2" disableRipple={true} label={t('flowGroups.left.tabs.attributes.title')} />
        </Tabs>

        {/*  PANEL: flowGroups  */}
        <TabPanel value={tabValue} index={0}>
          <FlowGroupsAccordion flowGroups={flowGroups} />
        </TabPanel>

        {/*  PANEL: actions  */}
        <TabPanel value={tabValue} index={1}>
          <div style={{ overflow: 'hidden auto', height: TAB_PANEL_HEIGHT }}>
            <FlowActionsAccordion
              currentProject={currentProject}
              currentScenario={currentScenario}
              currentFlowGroup={currentFlowGroup}
              tasks={taskItems}
              conditions={conditionItems}
            />
          </div>
        </TabPanel>

        {/* PANEL: attributes */}
        <TabPanel value={tabValue} index={2}>
          <ScenarioAttributesTabs
            currentProject={currentProject}
            currentScenario={currentScenario}
            loadData={loadData}
            resources={resourceItems}
            variables={variableItems}
            products={productItems}
            locations={locationItems}
            weather_data={weatherItems}
            parameters={parameterItems}
          />
        </TabPanel>
      </TabContext>
    </div>
  ) : (
    <></>
  )
}

FlowListTabs.displayName = 'FlowListTabs'

FlowListTabs.propTypes = {
  currentProject: PropTypes.object.isRequired,
  currentScenario: PropTypes.object.isRequired,
  currentFlowGroup: PropTypes.object,
  flowGroups: PropTypes.array.isRequired,
  loadData: PropTypes.arrayOf(PropTypes.object).isRequired,
  // -- Scenario's Attributes
  resourceItems: PropTypes.arrayOf(PropTypes.object),
  productItems: PropTypes.arrayOf(PropTypes.object),
  variableItems: PropTypes.arrayOf(PropTypes.object),
  locationItems: PropTypes.arrayOf(PropTypes.object),
  weatherItems: PropTypes.arrayOf(PropTypes.object),
  parameterItems: PropTypes.arrayOf(PropTypes.object),
  // -- flowGroup' Actions
  taskItems: PropTypes.arrayOf(PropTypes.object),
  conditionItems: PropTypes.arrayOf(PropTypes.object)
}

FlowListTabs.defaultProps = {
  currentProject: null,
  currentScenario: null,
  currentFlowGroup: null,
  flowGroups: null,
  loadData: [],
  // -- Scenario's Attributes
  resourceItems: [],
  productItems: [],
  variableItems: [],
  locationItems: [],
  weatherItems: [],
  parameterItems: [],
  // -- flowGroup' Actions
  taskItems: [],
  conditionItems: []
}
